var React = require('react');

function SalesforceCloud (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#F6F2FD","key":0}),React.createElement("path",{"d":"M38.3846 51.7983H26.913C23.8696 51.7983 19 48.9359 19 42.4651C19 36.7613 24.4609 33.8578 27.7073 33.6502C27.9102 30.3317 31.4174 23.7983 39.6957 23.7983C47.9739 23.7983 50.8551 31.2651 51.2609 34.9985C53.6957 34.9985 61 36.1182 61 43.087C61 50.0559 56.1304 51.7983 53.087 51.7983H52.3846","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M45.3884 57.3367V42.2598M45.3884 42.2598L41.6191 46.2507M45.3884 42.2598L49.1576 46.2507","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

SalesforceCloud.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = SalesforceCloud;

SalesforceCloud.default = SalesforceCloud;
